import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { get as getCookie } from 'js-cookie';
import styled, { css } from 'styled-components';
import { updateItem } from 'ducks/cart';
import { Button } from 'components/shared';
import guestCartCookieName from 'helpers/guestCartCookieName';
import QuantitySelector from './QuantitySelector';
import RecurringToggle from './RecurringToggle';

const Wrapper = styled.div`
  ${props =>
    css`
    display: ${props.isVisible ? 'block' : 'none'} }
    `};
`;

class UpdateCartItem extends React.Component {
  static propTypes = {
    cartItem: PropTypes.shape({
      id: PropTypes.integer,
      quantity: PropTypes.integer,
      recurring: PropTypes.boolean,
    }).isRequired,
    updateCartItem: PropTypes.func.isRequired,
    isVisible: PropTypes.bool.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      quantity: props.cartItem.quantity,
      recurring: props.cartItem.recurring,
      isSuccess: false,
      isLoading: false,
    };
    this.onUpdateCartItem = this.onUpdateCartItem.bind(this);
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      quantity: newProps.cartItem.quantity,
      recurring: newProps.cartItem.recurring,
      isSuccess: false,
      isLoading: false,
    });
  }

  async onUpdateCartItem() {
    const cartId = getCookie(guestCartCookieName);
    const { quantity, recurring } = this.state;
    this.setState({ isLoading: true });
    await this.props.updateCartItem(cartId, {
      id: this.props.cartItem.id,
      quantity,
      recurring,
    });
    this.setState({ isSuccess: true, isLoading: false });
    setTimeout(() => this.setState({ isSuccess: false }), 3000);
  }

  render() {
    const { cartItem } = this.props;
    const { isSuccess, isLoading, quantity, recurring } = this.state;

    if (cartItem.sellableType !== 'Product') return null;
    return (
      <Wrapper isVisible={this.props.isVisible}>
        {cartItem.allowsRecurringPurchase && (
          <RecurringToggle
            recurring={recurring}
            onChange={() => this.setState({ recurring: !recurring })}
          />
        )}
        <span>
          <QuantitySelector
            quantity={quantity}
            onChange={change => this.setState({ quantity: quantity + change })}
          />
        </span>
        <Button
          block
          inverse
          royal
          green={isSuccess}
          disabled={isSuccess}
          isLoading={isLoading}
          onClick={this.onUpdateCartItem}
        >
          {isSuccess && 'Updated'}
          {!isLoading && !isSuccess && 'Update'}
        </Button>
      </Wrapper>
    );
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = {
  updateCartItem: updateItem,
};
export default connect(mapStateToProps, mapDispatchToProps)(UpdateCartItem);



// WEBPACK FOOTER //
// ./src/components/shared/UpdateCartItem/UpdateCartItem.jsx